"use client";
import { useQuery } from "@tanstack/react-query";
import { apiConfig } from "../../config";
import ApiCompany from "./api-company";
import { getKey } from "../../common-interfaces/quiries-keys/queries-keys";
import { Keys } from "../../common-interfaces/quiries-keys/keysValues";
import { getLangCookie } from "@/utils/functions/cookieOperations";

export const useCompany = () => new ApiCompany(apiConfig());
export const useGetCompanyQuery = () => {
  return useQuery(
    [Keys.company, getLangCookie() ?? ""],
    useCompany().getCompany,
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  );
};
export const useGetDialCodesQuery = () => {
  return useQuery([...getKey(Keys.get_dial_codes)], useCompany().getDialCodes, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
export const useGetAllTransQuery = () => {
  return useQuery([...getKey(Keys.trans)], useCompany().getAllTranslations, {
    refetchOnWindowFocus: true,
    staleTime: Infinity,
  });
};

export const useGetCurrenciesQuery = () => {
  return useQuery([...getKey(Keys.currencies)], useCompany().getCurrencies, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
